/* GarageWhiz editable testimonials and service-gallery interactions. */
(function () {
  function reviewSliders() {
    document.querySelectorAll('[data-review-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-review-track]');
      var slides = track ? Array.prototype.slice.call(track.children) : [];
      var index = 0;
      if (!track || slides.length < 2) return;
      function visibleCards() {
        if (window.innerWidth < 700) return 1;
        if (window.innerWidth < 1024) return 2;
        return Number(slider.getAttribute('data-review-per-view')) || 4;
      }
      function move() {
        var visible = visibleCards();
        var max = Math.max(0, slides.length - visible);
        index = Math.min(index, max);
        var step = 100 / visible;
        track.style.transform = 'translateX(-' + (index * step) + '%)';
      }
      var next = slider.querySelector('[data-review-next]');
      var prev = slider.querySelector('[data-review-prev]');
      if (next) next.addEventListener('click', function () { var max = Math.max(0, slides.length - visibleCards()); index = index >= max ? 0 : index + 1; move(); });
      if (prev) prev.addEventListener('click', function () { var max = Math.max(0, slides.length - visibleCards()); index = index <= 0 ? max : index - 1; move(); });
      window.addEventListener('resize', move);
      move();
    });
  }

  function galleryTabs() {
    document.querySelectorAll('[data-service-gallery]').forEach(function (gallery) {
      gallery.querySelectorAll('[data-gallery-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-gallery-tab');
          gallery.querySelectorAll('[data-gallery-tab]').forEach(function (item) { item.classList.toggle('is-active', item === tab); });
          gallery.querySelectorAll('.service-gallery__panel').forEach(function (panel) { panel.classList.toggle('is-active', panel.id === target); });
        });
      });
    });
  }

  function lightbox() {
    var modal = document.createElement('div');
    modal.className = 'garagewhiz-lightbox';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = '<div class="garagewhiz-lightbox__frame"><button type="button" class="garagewhiz-lightbox__close" aria-label="Close full image">×</button><img alt="Expanded gallery image"><p class="garagewhiz-lightbox__caption" hidden></p></div>';
    document.body.appendChild(modal);
    var image = modal.querySelector('img');
    var caption = modal.querySelector('.garagewhiz-lightbox__caption');
    function open(source, alt, captionText) {
      if (!source) return;
      image.src = source;
      image.alt = alt || '';
      caption.textContent = captionText || '';
      caption.hidden = !captionText;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('garagewhiz-lightbox-open');
      modal.querySelector('.garagewhiz-lightbox__close').focus();
    }
    function close() { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.classList.remove('garagewhiz-lightbox-open'); image.removeAttribute('src'); caption.textContent = ''; caption.hidden = true; }
    modal.addEventListener('click', function (event) { if (event.target === modal || event.target.closest('.garagewhiz-lightbox__close')) close(); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') close(); });
    document.addEventListener('click', function (event) {
      var galleryButton = event.target.closest('[data-gallery-image-src]');
      if (galleryButton) {
        open(galleryButton.getAttribute('data-gallery-image-src'), galleryButton.getAttribute('data-gallery-image-alt'), galleryButton.getAttribute('data-gallery-caption'));
        return;
      }
      var portfolioImage = event.target.closest('.portfolio__image-wrap');
      if (portfolioImage) {
        var imageElement = portfolioImage.querySelector('img');
        if (imageElement) open(imageElement.currentSrc || imageElement.getAttribute('src'), imageElement.getAttribute('alt'), portfolioImage.getAttribute('data-gallery-caption'));
      }
    });
  }

  function init() { reviewSliders(); galleryTabs(); lightbox(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();